"use client"

import { ChevronUp } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChevronUpIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChevronUpIcon = component(Icon)({ as: ChevronUp })
